import { render, staticRenderFns } from "./FormUnitGroupLocale.vue?vue&type=template&id=6c01e54f&scoped=true&"
import script from "./FormUnitGroupLocale.vue?vue&type=script&lang=js&"
export * from "./FormUnitGroupLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01e54f",
  null
  
)

export default component.exports